// Central site data for PRYME EPOXY

export const SITE_URL = "https://prymeepoxy.com";
export const PHONE_DISPLAY = "(928) 583-8100";
export const PHONE_TEL = "tel:+19285838100";
export const EMAIL = "prymeepoxy@gmail.com";
// Physical HQ (real, verifiable). PRYME travels to serve all of Northern Arizona.
export const LOCATION = "Mayer, Arizona";
export const ADDRESS = {
  street: "17791 E Bob White Rd",
  city: "Mayer",
  region: "AZ",
  postalCode: "86333",
  country: "US",
};
// Primary markets first, then additional legitimately-served communities.
export const SERVICE_AREA = "Northern Arizona";
// Manual Google review stats fallback (used until the live Places API is enabled).
export const REVIEW_RATING = 5.0;
export const REVIEW_COUNT = 84;
export const SOCIAL = {
  instagram: "https://www.instagram.com/pryme_epoxy",
  facebook: "https://www.facebook.com/share/1EH2gp2xTy/",
};

export const IMG = {
  logo: "/images/logo.png",
  // Real project photos
  blackGarage: "/images/tyler1.jpg",
  roundRoom: "/images/tyler2.jpg",
  metallic: "/images/metallic.jpg",
  metallicCopper: "/images/metallic-copper.jpg",
  metallicSilver: "/images/metallic-silver.jpg",
  metallicRedChevy: "/images/metallic-red-chevy.jpg",
  metallicRedShop: "/images/metallic-red-shop.jpg",
  metallicSilverHall: "/images/metallic-silver-hall.jpg",
  grayFlake: "/images/gray-flake.jpg",
  hexLed: "/images/hexled.jpg",
  flakeTruck: "/images/flake-truck-garage.jpg",
  tylerFamily: "/images/tyler-family.jpg",
  // Stock support imagery
  heroBg: "/images/flake-truck-garage.jpg",
  beforeConcrete: "https://images.unsplash.com/photo-1618579830810-e89b6d35ff56?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  commercialWarehouse: "/images/commercial-real.jpg",
  commercialPaint: "/images/commercial-machine-shop.jpg",
  commercialGloss: "/images/commercial-warehouse-doors.jpg",
  commercialFlakeRoom1: "/images/commercial-flake-room1.jpg",
  commercialFlakeRooms: "/images/commercial-flake-rooms.jpg",
  commercialFlakeHall: "/images/commercial-flake-hall.jpg",
  processGrind: "/images/crew-grinding.jpg",
  processSaw: "https://images.pexels.com/photos/21366138/pexels-photo-21366138.jpeg?auto=compress&cs=tinysrgb&w=1400",
  seniorCouple: "https://images.pexels.com/photos/5790828/pexels-photo-5790828.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

export const CITIES = [
  "Prescott", "Flagstaff", "Sedona", "Prescott Valley", "Chino Valley",
  "Dewey-Humboldt", "Mayer", "Cottonwood", "Camp Verde", "Williams",
  "Kingman", "Payson", "Show Low",
];

export const SERVICES = [
  "Polyaspartic Garage Floor Coatings",
  "Epoxy Garage Floor Coatings",
  "Residential Flake Floors",
  "Polyaspartic Patio Coatings",
  "Concrete Grind & Seal",
  "Polished Concrete",
  "Commercial Floor Coatings",
  "Industrial Floor Coatings",
  "Industrial Coating Systems",
];

export const RESIDENTIAL_SERVICES = [
  {
    title: "Polyaspartic Garage Coatings",
    desc: "Four times stronger than store-bought epoxy. Installed in a single day and ready for your vehicles within 24 hours.",
  },
  {
    title: "Epoxy Garage Coatings",
    desc: "Industrial high-solids epoxy built for heavy loads. Resists gasoline, hot-tire pickup, impact and battery acid.",
  },
  {
    title: "Residential Flake Floors",
    desc: "Heavy broadcast colored chips finished with a polyaspartic topcoat. A textured, slip-resistant, beautiful surface.",
  },
  {
    title: "Polyaspartic Patio Coatings",
    desc: "UV-stable coatings made to handle the intense Northern Arizona sun without yellowing, chalking or cracking.",
  },
];

export const COMMERCIAL_SERVICES = [
  {
    title: "Concrete Grind & Seal",
    desc: "Premium surface grinding and high-grade penetrating sealers for clean, dust-free industrial workspaces.",
  },
  {
    title: "Polished Concrete",
    desc: "Multi-step mechanical diamond polishing and chemical densifying for a glossy, low-maintenance, heavy-duty floor.",
  },
  {
    title: "Commercial Floor Coatings",
    desc: "Durable coatings for showrooms, retail and offices that stand up to constant foot and cart traffic.",
  },
  {
    title: "Industrial Coating Systems",
    desc: "Extreme-duty chemical-resistant mortars, moisture vapor barriers and thick-film self-leveling epoxy systems.",
  },
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Free On-Site Estimate",
    desc: "Tyler personally visits your property, inspects the concrete, listens to your goals and gives you an honest, transparent quote.",
  },
  {
    step: "02",
    title: "Diamond Grinding & Prep",
    desc: "We grind every slab with planetary diamond grinders to open the concrete pores — the step cheap contractors skip.",
  },
  {
    step: "03",
    title: "Crack & Repair Work",
    desc: "Cracks and pits are filled with heavy structural polyurea so your finished floor is flawless and permanent.",
  },
  {
    step: "04",
    title: "Coating & Flake Broadcast",
    desc: "We apply premium industrial-grade base coats and hand-broadcast your chosen flake to full refusal.",
  },
  {
    step: "05",
    title: "Polyaspartic Topcoat",
    desc: "A crystal-clear, UV-stable polyaspartic topcoat seals everything in. You're back on the floor within 24 hours.",
  },
];

export const REVIEWS = [
  {
    name: "Linda M.",
    city: "Prescott, AZ",
    text: "Tyler was on time, polite and treated our home with real respect. The garage floor looks better than the showroom we saw. You can tell they don't cut corners.",
  },
  {
    name: "Robert & Carol S.",
    city: "Prescott Valley, AZ",
    text: "We are in our 70s and were nervous about hiring a contractor. Tyler explained everything in plain language and answered the phone every time. Wonderful experience.",
  },
  {
    name: "James T.",
    city: "Flagstaff, AZ",
    text: "Had three quotes. PRYME wasn't the cheapest but Tyler was the only one who talked about prep and grinding. Two winters later it still looks brand new.",
  },
  {
    name: "Dale W.",
    city: "Sedona, AZ",
    text: "Our patio coating is gorgeous and has held up to the sun beautifully. Honest, dependable people. We've already recommended them to two neighbors.",
  },
  {
    name: "Patricia H.",
    city: "Cottonwood, AZ",
    text: "From the first phone call to the final walkthrough, everything was professional and clean. Worth every penny. These are the guys you want.",
  },
  {
    name: "Greg N.",
    city: "Chino Valley, AZ",
    text: "Commercial grind and seal for our shop. Done on schedule, zero mess, looks fantastic. Tyler clearly cares about doing it right the first time.",
  },
];

export const GALLERY = [
  { src: IMG.metallicCopper, label: "Copper Metallic Interior", city: "Prescott", category: "Metallic Floors" },
  { src: IMG.metallicRedChevy, label: "Silver Metallic Office Hallway", city: "Flagstaff", category: "Metallic Floors" },
  { src: IMG.metallicRedShop, label: "Red Metallic Workshop Floor", city: "Prescott Valley", category: "Metallic Floors" },
  { src: IMG.blackGarage, label: "High-Gloss Black Garage", city: "Prescott", category: "Residential Garage Floors" },
  { src: IMG.metallic, label: "Silver Metallic Finish", city: "Sedona", category: "Metallic Floors" },
  { src: IMG.flakeTruck, label: "Granite Flake Garage", city: "Prescott", category: "Residential Garage Floors" },
  { src: IMG.roundRoom, label: "Basic Epoxy Flooring", city: "Prescott Valley", category: "Polished Concrete" },
  { src: IMG.commercialWarehouse, label: "Polished Commercial Floor", city: "Flagstaff", category: "Commercial Floors" },
  { src: IMG.commercialPaint, label: "Industrial Warehouse Coating", city: "Cottonwood", category: "Commercial Floors" },
];

export const GALLERY_CATEGORIES = ["All", "Residential Garage Floors", "Metallic Floors", "Commercial Floors", "Polished Concrete"];
